module.exports = __webpack_public_path__ + "media/images/plans/photo_location/point-3-b154b59ee77c0626d99f9645ce83b61d.jpg";